import { UserRole } from '@/types'
import { httpClient } from './httpClient'

interface GetScheduleNotesRequestPayload {
  scheduleId: number
  roles: UserRole[]
}

interface AddScheduleNotePayload {
  scheduleId: number
  notes: {
    text: string
    order: number
  }[]
}

interface DeleteScheduleNotePayload {
  scheduleId: number
  noteIds: number[]
}

interface EditScheduleNotePayload {
  scheduleId: number
  notes: { id: number; text?: string; order?: number }[]
}

export async function getScheduleNotes ({
  scheduleId,
  roles
}: GetScheduleNotesRequestPayload) {
  try {
    let url = import.meta.env.VITE_SCHEDULE_GET_NOTES_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: roles.includes('doctor')
        ? import.meta.env.VITE_API_MAIN_BASEURL
        : import.meta.env.VITE_API_PATIENT_BASEURL,
      url,
      method: 'GET',
      withCredentials: true,
      cache: false
    })

    if (!response) throw Error

    return response.data
  } catch (error) {
    console.error('getScheduleNotes - Error: ', error)
    throw error
  }
}

export async function addBatchScheduleNote ({
  scheduleId,
  notes
}: AddScheduleNotePayload) {
  try {
    let url = import.meta.env.VITE_BATCH_SCHEDULE_ADD_NOTE_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'POST',
      withCredentials: true,
      data: {
        notes
      }
    })

    if (!response) throw Error

    return response
  } catch (error: any) {
    console.error('addBatchScheduleNote - Error: ', error)
    throw error
  }
}

export async function deleteBatchScheduleNote ({
  scheduleId,
  noteIds
}: DeleteScheduleNotePayload) {
  try {
    let url = import.meta.env.VITE_BATCH_DELETE_NOTES_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'DELETE',
      withCredentials: true,
      data: { noteIds }
    })

    if (!response) throw Error

    return response
  } catch (error: any) {
    console.error('deleteBatchScheduleNote - Error: ', error)
    throw error
  }
}

export async function editBatchScheduleNote ({
  scheduleId,
  notes
}: EditScheduleNotePayload) {
  try {
    let url = import.meta.env.VITE_BATCH_SCHEDULE_UPDATE_NOTE_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'PUT',
      data: {
        notes
      },
      withCredentials: true
    })

    if (!response) throw Error

    return response
  } catch (error: any) {
    console.error('editBatchScheduleNote - Error: ', error)
    throw error
  }
}
